<template>
    <el-card style="width: 100%" class="card_xjqd">
        <h2 class="xpqd">询盘清单</h2>
        <page-wrap>
            <!-- 搜索栏 -->
            <search-wrap>
                <el-form :model="search" label-width="75px" size="mini" onsubmit="return false" :inline="true">
                    <el-row>
                        <el-col :span="20">
                            <div class="bg">
                                <el-form-item label="联系人:">
                                    <el-input v-model="search.contact" placeholder="请输入" @keyup.enter.native="onSubmit()"></el-input>
                                </el-form-item>
                                <el-form-item label="电话:">
                                    <el-input v-model="search.phone" placeholder="请输入" @keyup.enter.native="onSubmit()"></el-input>
                                </el-form-item>
                                <el-form-item label="备注留言:">
                                    <el-input v-model="search.content" placeholder="请输入" @keyup.enter.native="onSubmit()"></el-input>
                                </el-form-item>
                                <el-form-item label="留言时间:">
                                    <el-date-picker v-model="search.add_time" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="4">
                            <el-button type="primary" size="mini" @click="onSubmit()" icon="el-icon-search" title="查询黑名单">查询</el-button>
                            <el-button type="danger" size="mini" @click="onClear()" icon='el-icon-refresh' title="重置搜索条件">重置</el-button>
                            <!--<el-button type="success" size="mini" @click="handleAddIf=true" icon='el-icon-plus' title="添加黑名单">添加</el-button>-->
                        </el-col>
                    </el-row>
                </el-form>
            </search-wrap>
            <!-- 表格 -->
            <table-wrap>
                <el-table ref="table" :data="tableData" :height="tableHeight" style="width: 100%">
                    <!--<el-table-column label="操作" min-width='50'>-->
                    <!--<template slot-scope="scope">-->
                    <!--&lt;!&ndash;<el-button @click="onEdit(scope.row)" type="text" size="small" icon='el-icon-edit' title="编辑"></el-button>&ndash;&gt;-->
                    <!--<el-button @click="onDelete(scope.row)" type="text" size="small" icon='el-icon-delete' title="删除黑名单"></el-button>-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <el-table-column label="留言时间" prop="" min-width='50'>
                        <template slot-scope="scope">
                            {{scope.row.add_time.slice(0,10)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="联系人" prop="contact" min-width='50'>
                    </el-table-column>
                    <el-table-column label="电话" prop="phone" min-width='50'>
                    </el-table-column>
                    <el-table-column label="备注留言" prop="content" min-width='100'>
                    </el-table-column>
                </el-table>

            </table-wrap>

            <!-- 分页 -->
            <pagination :data="pagination" @submit="onSubmit" />
            <add v-if="handleAddIf" @callback="callbackAdd" />
            <edit v-if="handleEditIf" :list="rowIndex" @callback="callbackEdit" />
        </page-wrap>
    </el-card>
</template>


<script>
import Add from "./Add.vue";
import Edit from "./Edit.vue";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
    components: {
        Add,
        Edit
    },
    data() {
        return {
            search: { phone: "", add_time: "", contact: "" ,content:""}, // 搜索词
            pagination: { currentPage: 1, pageSize: 50, total: 0 }, // 分页相关数据
            loading: false,
            tableData: [],
            tableHeight:null,
            handleAddIf: false,
            handleEditIf: false,
            rowIndex: {},
            TmpOptions: [],
            TmpOptions1: [
                {
                    value: "1",
                    label: "正常"
                },
                {
                    value: "2",
                    label: "停用"
                }
            ]
        };
    },
    computed: {
    },
    mounted() {
        let p = document.getElementsByClassName('paginationWrap')[0].offsetTop;
        let t = document.getElementsByClassName('tableWrap')[0].offsetTop;
        let h = document.getElementsByClassName('el-table__header-wrapper')[0].offsetHeight;
        this.tableHeight =  p - h - t;
        this.onSubmit();
    },
    watch: {},
    methods: {
        onSubmit(pagination = null) {
            let that = this;
            if (pagination !== null) {
                that.pagination = pagination;
            } else {
                that.pagination.currentPage = 1;
            }
            if (this.loading) {
                return;
            }
            if (that.ifparam) {
                that.ifparam = false;
                that.search.company_name = that.param.company_name;
            }
            this.$ajax
                .post("/page/Xpqd/index", {
                    search: that.search,
                    paginate: that.pagination
                })
                .then(function(res) {
                    if (res.data.error === 0) {
                        that.tableData = res.data.data.data;
                        that.pagination.total = res.data.data.total;
                        that.loading = false;
                    }
                })
                .catch(function(err) {
                    that.$message("网络错误！请联系管理员");
                    that.loading = false;
                });
        },
        onClear() {
            for (let key in this.search) {
                this.search[key] = "";
            }
        },

        callbackAdd(data) {
            this.handleAddIf = false;
            if (data) {
                this.$message({
                    type: "success",
                    message: "添加成功!"
                });
                this.onSubmit(this.pagination);
            }
        },
        callbackEdit(data) {
            this.handleEditIf = false;
            if (data) {
                this.$message({
                    type: "success",
                    message: "编辑成功!"
                });
                this.onSubmit(this.pagination);
            }
        },
        onDelete(row) {
            let that = this;
            this.$confirm("确定删除此电话黑名单吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    this.$ajax
                        .post("admin/Blacklist/delete", { pb_id: row.pb_id })
                        .then(function(res) {
                            if (res.data.error === 0) {
                                that.$message({
                                    type: "success",
                                    message: "删除成功!"
                                });
                                that.onSubmit(that.pagination);
                            } else {
                                that.$message(res.data.message);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
     onEdit(row) {
            let arr = [];
            let s = {};
            for (let key in row) {
                if (arr.includes(key)){
                    s[key] = parseInt(row[key]);
                    if (s[key] === 0){
                        s[key] = ''
                    }
                }else{
                    s[key] = row[key]
                }
            }
            this.rowIndex = s;
            this.handleEditIf = true;
        },
    }
};
</script>


// WEBPACK FOOTER //
// src/views/page/xpqd/Index.vue